import { Injectable } from '@angular/core';
import { AssignmentContext, AssessmentLaunch } from '@mhe/reader/models';
import { Observable } from 'rxjs';

import { ApiClientSelectorService } from './api-client-selector.service';
import { AssignmentsService } from './player-api/assignments.service';
import { ReaderApiAssignmentsService } from './reader-api/assignments.service';
import { AssessmentService } from './player-api/assessment.service';
import { ReaderApiAssessmentService } from './reader-api/assessment.service';

// Component-scoped because it injects ReaderApiAssignmentsService, which depends on ReducedModeUtils.
@Injectable()
export class AssignmentServiceSelectorService {
  constructor(
    private readonly apiClientSelector: ApiClientSelectorService,
    private readonly playerAssignments: AssignmentsService,
    private readonly readerAssignments: ReaderApiAssignmentsService,
    private readonly playerAssessment: AssessmentService,
    private readonly readerAssessment: ReaderApiAssessmentService,
  ) {}

  submit(apiBaseUrl: string, assignmentContext: AssignmentContext): Observable<any> {
    return this.getAssignmentsService().submit(apiBaseUrl, assignmentContext);
  }

  handleAssignmentLexileLevel(apiBaseUrl: string, lexileLevel: string): Observable<any> {
    return this.getAssignmentsService().handleAssignmentLexileLevel(apiBaseUrl, lexileLevel);
  }

  refreshAssessmentParams(api: string): Observable<AssessmentLaunch> {
    return this.getAssessmentService().refreshParams(api);
  }

  private getAssignmentsService(): AssignmentsService | ReaderApiAssignmentsService {
    return this.apiClientSelector.isUsingReaderApi()
      ? this.readerAssignments
      : this.playerAssignments;
  }

  private getAssessmentService(): AssessmentService | ReaderApiAssessmentService {
    return this.apiClientSelector.isUsingReaderApi()
      ? this.readerAssessment
      : this.playerAssessment;
  }
}
